import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../typesNew";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => {
  if (state && state.dashboardState) {
    return state.dashboardState;
  } else {
    return initialState;
  }
};
export const selectEndDate = createSelector(
  [selectDomain],
  (state) => state.endDate
);
export const selectFilterValue = createSelector(
  [selectDomain],
  (state) => state.filterValue
);
export const selectStartDate = createSelector(
  [selectDomain],
  (state) => state.startDate
);
export const SelectChartData = createSelector(
  [selectDomain],
  (state) => state.chartData
);
export const SelectDashboardFormData = createSelector(
  [selectDomain],
  (state) => state.DashboardFormData
);
